<btn [text]="this.typeOperation=='signin'? 'Sign in with Google' :'Sign up with Google'" bcg="white" (click)="onGoogleAuthorizationClick()" svgLeft='google&24'></btn>
